import React, { useState, useRef } from 'react';
import { Dialog } from '@headlessui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlay,  } from '@fortawesome/free-solid-svg-icons';
import videoBanner from '../assets/latapatia.mp4';
import reel from '../assets/reel.mp4'; // <-- Importa el reel


export default function Nosotros() {

  const [isOpen, setIsOpen] = useState(false);
  const bannerRef = useRef(null);

  const openModal = () => {
    if (bannerRef.current) {
      bannerRef.current.pause(); // Pausar video principal
    }
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
    if (bannerRef.current) {
      bannerRef.current.play(); // Reanudar video principal al cerrar
    }
  };
  
  return (
    <div className="bg-[#f28c281a]">
      {/* Banner de video */}
      <div className="w-full bg-black relative flex justify-center items-center overflow-hidden">
        <video
          className="w-full h-auto max-h-[60vh] object-contain"
          autoPlay
          loop
          muted
          playsInline
        >
          <source src={videoBanner} type="video/mp4" />
          Tu navegador no soporta el video.
        </video>
        <div className="absolute inset-0 bg-black/20"></div>
      </div>

      {/* Reel Video Section */}
      <div className="bg-[#f28c28]/10 py-8">
        <div className="max-w-xs md:max-w-sm mx-auto text-center">
          <div className="relative rounded-xl overflow-hidden shadow-xl mb-4 border border-orange-300">
            <video
              ref={bannerRef}
              src={reel}
              controls
              className="w-full aspect-[9/16] object-cover rounded-xl"
            >
              Tu navegador no soporta el video.
            </video>
          </div>
          <button
            onClick={openModal}
            className="px-4 py-2 bg-orange-500 hover:bg-orange-600 text-white rounded-lg text-sm shadow inline-flex items-center gap-2"
          >
            <FontAwesomeIcon icon={faPlay} /> Ver en pantalla completa
          </button>
        </div>
      </div>

      {/* Modal para reel */}
      <Dialog open={isOpen} onClose={closeModal} className="relative z-50">
        <div className="fixed inset-0 bg-black/80 flex items-center justify-center p-4">
          <Dialog.Panel className="max-w-sm w-full relative">
            <video
              src={reel}
              controls
              autoPlay
              className="w-full aspect-[9/16] object-cover rounded-xl shadow-lg"
            >
              Tu navegador no soporta el video.
            </video>
            <button
              onClick={closeModal}
              className="absolute top-2 right-2 text-white text-2xl hover:text-red-400"
            >
              ✕
            </button>
          </Dialog.Panel>
        </div>
      </Dialog>

      {/* Contenido textual */}
      <section className="max-w-4xl mx-auto py-12 px-6">
        <h2 className="text-3xl font-semibold mb-4 text-[#0033A0] text-center">Nosotros</h2>
        <p className="text-gray-700 leading-relaxed mb-4">
          En <strong>La Tapatía El Grullo</strong>, nos sentimos orgullosos de ser un negocio local que forma parte
          activa de la vida diaria de nuestra comunidad. Nuestra historia nace del compromiso por ofrecer una
          alternativa cercana, accesible y confiable para todas las familias que buscan calidad, buen servicio y
          atención personalizada en sus compras cotidianas.
        </p>
        <p className="text-gray-700 leading-relaxed mb-4">
          Desde nuestros inicios, nos hemos dedicado a ofrecer una amplia variedad de productos para satisfacer las
          necesidades del hogar, del negocio o del cliente que busca conveniencia. Contamos con un extenso surtido que
          abarca desde frutas y verduras frescas, seleccionadas cuidadosamente cada día, hasta granos, cereales y
          lácteos de excelente calidad. También encontrarás abarrotes de marcas reconocidas, dulces tradicionales,
          vinos y licores, desechables, artículos de limpieza y alimento para tus mascotas. Todo en un mismo lugar.
        </p>
        <p className="text-gray-700 leading-relaxed mb-4">
          Pero en La Tapatía no solo nos enfocamos en el producto. Para nosotros, lo más importante es la experiencia
          del cliente. Por eso, te ofrecemos un ambiente cálido, atención amable y precios justos. Cada persona que
          entra a nuestra tienda es recibida con respeto y cercanía, como parte de la familia. Nos esforzamos día a
          día para que tu visita sea rápida, agradable y eficiente.
        </p>
        <p className="text-gray-700 leading-relaxed mb-4">
          Entendemos que el tiempo de nuestros clientes es valioso. Por eso, hemos incorporado el <strong>servicio a
            domicilio</strong>, pensado especialmente para personas mayores, familias ocupadas o quienes simplemente
          prefieren la comodidad de recibir sus productos en casa. Solo necesitas contactarnos por teléfono o
          WhatsApp, y con gusto llevamos tu pedido hasta tu puerta, con la misma calidad y atención que si estuvieras
          en el mostrador.
        </p>
        <p className="text-gray-700 leading-relaxed mb-4">
          Ubicados en <strong>López Rayón #18</strong>, en el corazón de El Grullo, nos sentimos parte del día a día
          de muchas personas que nos han acompañado desde hace años y de nuevos clientes que confían en nosotros.
          Sabemos que cada producto que vendemos llega a una mesa, una celebración o una necesidad, y por eso
          trabajamos con responsabilidad y pasión.
        </p>
        <p className="text-gray-700 leading-relaxed">
          Gracias por permitirnos ser parte de tu vida cotidiana. En La Tapatía El Grullo seguimos creciendo contigo,
          con el mismo compromiso de siempre: ofrecerte calidad, frescura, confianza y ese trato cálido que nos
          distingue como un auténtico súper de barrio, con alma de familia.
        </p>
      </section>
    </div>
  );
}
